import dayjs, { Dayjs } from "dayjs"
import { DateTimeValidationError } from "@mui/x-date-pickers"
import { TimePreset } from "../../../../../Managers/VisualizationManager/Viewport/Components/XAxis"

export const toSecondPrecision = (value: dayjs.ConfigType): Dayjs =>
	dayjs(value).millisecond(0)

export const clampStartTime = (value: Dayjs, min: Dayjs, max: Dayjs): Dayjs => {
	if (value.isBefore(min)) {
		return min
	}

	if (value.isAfter(max)) {
		return max
	}

	return value
}

export const latestWindowStart = (fileStart: Dayjs, fileEnd: Dayjs, viewDurationMs: number): Dayjs => {
	const windowFitStart = fileEnd.subtract(viewDurationMs, "millisecond")
	return windowFitStart.isBefore(fileStart) ? fileStart : windowFitStart
}

export function formatViewDuration(milliseconds: number): string {
	if (isNaN(milliseconds)) {
		milliseconds = 0
	}

	const seconds = Math.floor(milliseconds / 1000)
	const minutes = Math.floor(seconds / 60)
	const hours = Math.floor(minutes / 60)
	const days = Math.floor(hours / 24)

	let formattedDays = ""
	if (days === 1) {
		formattedDays = `${days} Day `
	} else if (days > 1) {
		formattedDays = `${days} Days `
	}
	const formattedHours = hours % 24
	const formattedMinutes = minutes % 60
	const formattedSeconds = seconds % 60

	return `${formattedDays}${String(formattedHours).padStart(2, "0")}:${String(formattedMinutes).padStart(2, "0")}:${String(formattedSeconds).padStart(2, "0")}`
}

export const describeViewDuration = (presets: TimePreset[], viewDurationMs: number): string => {
	const preset = presets.find(candidate => candidate.time === viewDurationMs && candidate.time > 0)
	return preset ? preset.label : formatViewDuration(viewDurationMs)
}

export const describeFieldError = (error: DateTimeValidationError): string => {
	switch (error) {
		case "maxTime":
		case "maxDate":
			return "Time is after the end of the recording"

		case "minTime":
		case "minDate":
			return "Time is before the start of the recording"

		case "invalidDate":
			return "The specified date is invalid"

		default:
			return ""
	}
}
